var $b7a0e914f2f1fc45$exports = {};
$b7a0e914f2f1fc45$exports = {
  "collapse": "Colapsar",
  "expand": "Expandir"
};
export { $b7a0e914f2f1fc45$exports as default };